import { HttpService } from "../../../common/http/service/HttpService";
import {
    AdminAuthResponse,
    AdminLoginRequest,
    AdminMeResponse,
    Admin2FARequest,
} from "../model/AdminLoginTypes";

export class AdminLoginService {
    private static readonly ME_URL = "/admin/login/me";
    private static readonly LOGIN_URL = "/admin/login";
    private static readonly LOGIN_2FA_URL = "/admin/login/2fa";

    constructor(private readonly httpService: HttpService) {}

    /** GET /admin/login/me — current admin auth state (always 200). */
    getMe = (): Promise<AdminMeResponse> => {
        return this.httpService.fetchAs<AdminMeResponse>({
            url: AdminLoginService.ME_URL,
            method: "GET",
        });
    };

    /** POST /admin/login — email + password. 200 → requires2fa; 401 throws with error message. */
    login = (email: string, password: string): Promise<AdminAuthResponse> => {
        const body: AdminLoginRequest = { email, password };
        return this.httpService.fetchAs<AdminAuthResponse>({
            url: AdminLoginService.LOGIN_URL,
            method: "POST",
            data: body,
        });
    };

    /** POST /admin/login/2fa — verification code. 200 → success; 401 throws with error message. */
    submit2fa = (code: string): Promise<AdminAuthResponse> => {
        const body: Admin2FARequest = { code };
        return this.httpService.fetchAs<AdminAuthResponse>({
            url: AdminLoginService.LOGIN_2FA_URL,
            method: "POST",
            data: body,
        });
    };

    /** POST /admin/login/2fa/resend — request new MFA code. Uses same session cookie. */
    resend2fa = (): Promise<AdminAuthResponse> => {
        return this.httpService.fetchAs<AdminAuthResponse>({
            url: "/admin/login/2fa/resend",
            method: "POST",
        });
    };
}
